/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SelectBackend } from '../common';
import { setReviewMode } from '../common/redux/actions';

const { EcsterConfig: conf } = window;

class LoginHelpFooter extends React.Component {
    state = {
        count: 0,
        initialBaseUrl: window.sessionStorage.getItem('initialBaseUrl'), // set in index.js
    };

    cvRef = React.createRef();

    render() {
        const { canaryValue } = this.state;
        return (
            <>
                {conf && (
                    <p className="version-info">
                        version: {conf.version} {conf.build ? ` / ${conf.build}` : ''}
                    </p>
                )}

                {conf.env !== 'prod' && <SelectBackend />}
            </>
        );
    }
}

LoginHelpFooter.propTypes = {
    setReviewMode: PropTypes.func.isRequired,
    isReviewMode: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ common }) => ({
    isReviewMode: common.isReviewMode,
});

function mapDispatchToProps(dispatch) {
    return {
        setReviewMode: isReviewMode => dispatch(setReviewMode(isReviewMode)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginHelpFooter);
